import { FC } from 'react';
import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import { useRouter } from 'next/router';

import { Form, Packet, EnvironmentVariableProps } from '@forms-exp/types';
import { KioskLayout, KioskListing, FooterLinks } from '@forms-exp/components';
import { fetchKioskForms } from '@forms-exp/helpers';
import { getEnvProps } from '@forms-exp/env';
import { getCountryDropdownFlag } from '@/helpers/country-dropdown';

interface CompanyFormsProps extends EnvironmentVariableProps {
  isCountryDropdownEnabled: boolean;
  packets: Packet[];
  forms: Form[];
}

const CompanyFormsPage: FC<CompanyFormsProps> = ({
  forms,
  packets,
  isCountryDropdownEnabled,
}) => {
  const router = useRouter();
  const { companyId } = router.query as { companyId: string };

  return (
    <KioskLayout
      title="Select Form"
      companyId={companyId as string}
      isCountryDropdownEnabled={isCountryDropdownEnabled}
    >
      <KioskListing forms={forms} packets={packets} />
    </KioskLayout>
  );
};

export async function getServerSideProps(
  context: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<CompanyFormsProps>> {
  const { companyId } = context.query;

  try {
    const isCountryDropdownEnabled = await getCountryDropdownFlag(companyId as string);
    const {
      data: { packets, forms },
    } = await fetchKioskForms(companyId as string);

    return {
      props: {
        isCountryDropdownEnabled,
        packets,
        forms,
        ...getEnvProps(),
      },
    };
  } catch (err) {
    return {
      props: {
        isCountryDropdownEnabled: false,
        packets: [],
        forms: [],
        ...getEnvProps(),
      },
    };
  }
}

export default CompanyFormsPage;
